import React from "react";
import MicroIcon from "../brand/MicroIcon";
import { COLORS, SEASONS } from "../brand/tokens";

const previews = [
  {
    title: "Autumn Reflections",
    excerpt: "The season of grounding — how a slow walk under falling leaves reset my nervous system.",
    tag: "AUTUMN · GROUNDING",
    accent: SEASONS[2].accent,
  },
  {
    title: "Winter Restore",
    excerpt: "Rest is not the opposite of movement. In winter, we walk gently — and let the world be quiet.",
    tag: "WINTER · RESTORE",
    accent: SEASONS[3].accent,
  },
  {
    title: "Take one gentle step",
    excerpt: "A short reflection on why healing rarely arrives all at once — and often begins with a single, tender step.",
    tag: "MANIFESTO",
    accent: COLORS.gold,
  },
];

const JournalPage = () => (
  <main className="site-main" data-testid="page-journal">
    <section className="journal-hero">
      <p className="eyebrow">JOURNAL · SOFT REFLECTIONS</p>
      <h1>The Journal.</h1>
      <p className="lede">Monthly walks, seasonal reflections, and gentle wellness notes — for the days when life feels heavy and the mornings feel too early.</p>
    </section>

    <section className="journal-grid">
      {previews.map((p, i) => (
        <article className="journal-card" key={i} data-testid={`journal-card-${i}`}>
          <div className="journal-card__accent" style={{ background: p.accent }}>
            <MicroIcon size={44} color="#fff" />
          </div>
          <p className="eyebrow">{p.tag}</p>
          <h3>{p.title}</h3>
          <p>{p.excerpt}</p>
          <span className="journal-card__soon">Coming soon 🌿</span>
        </article>
      ))}
    </section>

    <section className="journal-note">
      <MicroIcon size={60} color={COLORS.gold} />
      <h2>The Journal opens with our first season.</h2>
      <p>Join the walk to be the first to read our reflections. One gentle letter per season — never spam, never rushed.</p>
    </section>
  </main>
);

export default JournalPage;
